<template>
  <div class="animated fadeIn col-md-12">
    <b-row>
      <b-col class="col-md-12 col-sm-12 col-lg-12">
        <b-card>
          <div slot="header">
            {{ $lang.assessment_plan_data }}
            <strong v-text="title"></strong>
          </div>
          <div v-show="errors.length > 0" class="alert-danger" dismissible>
            <h4>خطا:</h4>
            <ul v-bind:key="index" v-for="(error, index) in errors">
              <li>{{ error }}</li>
            </ul>
          </div>
          <b-form @submit.prevent="save" v-show="!isLoading">
            <b-row>
              <b-col cols="5">
                <b-form-group
                  label="تمرین"
                  label-for="category_id"
                  :label-cols="2"
                >
                  <requiredComponent
                    slot="label"
                    label="تمرین"
                    :rules="$v.exercise_detail_selected.$params"
                  />

                  <selectFind
                    :options="exercise_detail_options"
                    v-model="$v.exercise_detail_selected.$model"
                    label="text"
                    id="value"
                    :isValid="
                      $v.exercise_detail_selected.$dirty
                        ? !$v.exercise_detail_selected.$error
                        : null
                    "
                    :loading="exerciseAlgorithmDetailLoading"
                  />

                  <b-form-invalid-feedback id="category_id-feedback"
                    >دسته بندی ضروری است</b-form-invalid-feedback
                  >
                </b-form-group>
              </b-col>

              <b-col cols="3">
                <b-form-group
                  label="مخاطب"
                  label-for="category_id"
                  :label-cols="3"
                >
                  <requiredComponent
                    slot="label"
                    label="مخاطب"
                    :rules="$v.candidate_selected.$params"
                  />

                  <selectFind
                    :options="candidate_options"
                    v-model="$v.candidate_selected.$model"
                    label="text"
                    id="value"
                    :isValid="
                      $v.candidate_selected.$dirty
                        ? !$v.candidate_selected.$error
                        : null
                    "
                  />

                  <b-form-invalid-feedback id="category_id-feedback"
                    >دسته بندی ضروری است</b-form-invalid-feedback
                  >
                </b-form-group>
              </b-col>
              <b-col cols="2">
                <b-form-group
                  label="ارزیاب"
                  label-for="category_id"
                  :label-cols="3"
                >
                  <requiredComponent
                    slot="label"
                    label="ارزیاب"
                    :rules="$v.assessor_selected.$params"
                  />

                  <selectFind
                    :options="assessor_options"
                    v-model="$v.assessor_selected.$model"
                    label="text"
                    id="value"
                    :isValid="
                      $v.assessor_options.$dirty
                        ? !$v.assessor_options.$error
                        : null
                    "
                    :loading="assessorLoading"
                  />

                  <b-form-invalid-feedback id="category_id-feedback"
                    >دسته بندی ضروری است</b-form-invalid-feedback
                  >
                </b-form-group>
              </b-col>
              <b-col cols="2">
                <b-form-group
                  label="اتاق"
                  label-for="category_id"
                  :label-cols="2"
                >
                  <requiredComponent
                    slot="label"
                    label="اتاق"
                    :rules="$v.room_selected.$params"
                  />

                  <selectFind
                    :options="room_options"
                    v-model="$v.room_selected.$model"
                    label="text"
                    id="value"
                    :isValid="
                      $v.room_selected.$dirty ? !$v.room_selected.$error : null
                    "
                  />

                  <b-form-invalid-feedback id="category_id-feedback"
                    >دسته بندی ضروری است</b-form-invalid-feedback
                  >
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="5">
                <b-form-group label="زمان" label-for="time" :label-cols="2">
                  <requiredComponent
                    slot="label"
                    label="زمان شروع"
                    :rules="$v.time.$params"
                  />

                  <date-picker
                    v-model="$v.time.$model"
                    :state="$v.time.$dirty ? !$v.time.$error : null"
                    format="HH:mm"
                    display-format="HH:mm"
                    :min="start_time"
                    :jumpMinute="5"
                    :max="end_time"
                    type="time"
                    inputReq="true"
                    :roundMinute="true"
                    :class="
                      $v.time.$dirty
                        ? $v.time.$error
                          ? 'invalid-date'
                          : 'valid-date'
                        : null
                    "
                  >
                  </date-picker>

                  <b-form-invalid-feedback id="category_id-feedback"
                    >دسته بندی ضروری است</b-form-invalid-feedback
                  >
                </b-form-group>
              </b-col>
              <b-col cols="1">
                <b-button
                  type="submit"
                  size="md"
                  variant="primary"
                  v-text="$lang.submit"
                >
                  <i class="fas fa-dot-circle"></i>
                </b-button>
              </b-col>
            </b-row>

            <!-- <div slot="footer" class="form-group form-btn">
              <b-button type="submit" size="md" variant="primary" v-text="$lang.submit">
                <i class="fas fa-dot-circle"></i>
              </b-button>
            </div>-->
          </b-form>
          <div class="text-center" v-show="isLoading">
            <b-spinner variant="primary" label="Text Centered"></b-spinner>
          </div>
          <b-row>
            <b-col cols="8" class="my-3">
              <b-button-group size="md">
                <b-button variant="success" active>کلی</b-button>
                <b-button variant="info">تمرین</b-button>
                <b-button variant="warning">ارزیاب</b-button>
                <b-button variant="secondary">اتاق</b-button>
              </b-button-group>
            </b-col>
            <b-col cols="4" v-show="day_options && day_options.length > 1">
              <b-form-group label="روز" label-for="category_id" :label-cols="1">
                <requiredComponent
                  slot="label"
                  label="روز"
                  :rules="$v.day_selected.$params"
                />

                <selectFind
                  :options="day_options"
                  v-model="$v.day_selected.$model"
                  label="text"
                  id="category_id"
                  :isValid="
                    $v.day_selected.$dirty ? !$v.day_selected.$error : null
                  "
                />

                <b-form-invalid-feedback id="category_id-feedback"
                  >دسته بندی ضروری است</b-form-invalid-feedback
                >
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <table class="diary table b-table">
              <thead class="rowgroup">
                <tr class="dates">
                  <th class="empty"></th>
                  <th class="empty"></th>
                  <th :key="index" v-for="(field, index) in fields">
                    {{ field.label ? field.label : field }}
                  </th>
                </tr>
              </thead>
              <tbody class="rowgroup">
                <tr class="">
                  <th rowspan="2" class="hour">00</th>
                  <th class="slot">00</th>
                  <td>
                    <div class="appointment hour3">
                      <div class="spanContainer">
                        <div class="inner">
                          <p>
                            "مصاحبه شایستگی‌محور-مصاحبه-اجرای مصاحبه 45 دقیقه
                            ای"
                          </p>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr class="timeSlot">
                  <th class="slot">30</th>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <th rowspan="2" class="hour">01</th>
                  <th class="slot">00</th>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr class="timeSlot">
                  <th class="slot">30</th>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <th rowspan="2" class="hour">02</th>
                  <th class="slot">00</th>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr class="timeSlot">
                  <th class="slot">30</th>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <th rowspan="2" class="hour">03</th>
                  <th class="slot">00</th>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td>
                    <div class="appointment hour1">
                      <div class="spanContainer">
                        <div class="inner">
                          <h2>Weekly Technical Meeting</h2>
                          <ul>
                            <li>00:00 - 04:30</li>
                            <li>Chris Spittles</li>
                          </ul>
                          <p>
                            Valuable information regarding this event in the
                            calendar. Heavens above if something should ever
                            happen to this text.
                          </p>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr class="timeSlot">
                  <th class="slot">30</th>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <th rowspan="2" class="hour">04</th>
                  <th class="slot">00</th>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr class="timeSlot">
                  <th class="slot">30</th>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <th rowspan="2" class="hour">05</th>
                  <th class="slot">00</th>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr class="timeSlot">
                  <th class="slot">30</th>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <th rowspan="2" class="hour">06</th>
                  <th class="slot">00</th>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr class="timeSlot">
                  <th class="slot">30</th>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <th rowspan="2" class="hour">07</th>
                  <th class="slot">00</th>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr class="timeSlot">
                  <th class="slot">30</th>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <th rowspan="2" class="hour">08</th>
                  <th class="slot">00</th>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr class="timeSlot">
                  <th class="slot">30</th>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <th rowspan="2" class="hour">09</th>
                  <th class="slot">00</th>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr class="timeSlot">
                  <th class="slot">30</th>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <th rowspan="2" class="hour">10</th>
                  <th class="slot">00</th>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr class="timeSlot">
                  <th class="slot">30</th>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <th rowspan="2" class="hour">11</th>
                  <th class="slot">00</th>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr class="timeSlot">
                  <th class="slot">30</th>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <th rowspan="2" class="hour">12</th>
                  <th class="slot">00</th>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr class="timeSlot">
                  <th class="slot">30</th>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <th rowspan="2" class="hour">13</th>
                  <th class="slot">00</th>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr class="timeSlot">
                  <th class="slot">30</th>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <th rowspan="2" class="hour">14</th>
                  <th class="slot">00</th>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr class="timeSlot">
                  <th class="slot">30</th>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <th rowspan="2" class="hour">15</th>
                  <th class="slot">00</th>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr class="timeSlot">
                  <th class="slot">30</th>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <th rowspan="2" class="hour">16</th>
                  <th class="slot">00</th>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr class="timeSlot">
                  <th class="slot">30</th>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <th rowspan="2" class="hour">17</th>
                  <th class="slot">00</th>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr class="timeSlot">
                  <th class="slot">30</th>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <th rowspan="2" class="hour">18</th>
                  <th class="slot">00</th>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr class="timeSlot">
                  <th class="slot">30</th>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <th rowspan="2" class="hour">19</th>
                  <th class="slot">00</th>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr class="timeSlot">
                  <th class="slot">30</th>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <th rowspan="2" class="hour">20</th>
                  <th class="slot">00</th>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr class="timeSlot">
                  <th class="slot">30</th>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <th rowspan="2" class="hour">21</th>
                  <th class="slot">00</th>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr class="timeSlot">
                  <th class="slot">30</th>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <th rowspan="2" class="hour">22</th>
                  <th class="slot">00</th>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr class="timeSlot">
                  <th class="slot">30</th>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <th rowspan="2" class="hour">23</th>
                  <th class="slot">00</th>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr class="timeSlot">
                  <th class="slot">30</th>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </b-row>
        </b-card>
      </b-col>
      <!--/.col-->
    </b-row>
    <!--/.row-->
  </div>
</template>

<script>
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import { range } from "@/shared/utils";
import { required } from "vuelidate/lib/validators";

export default {
  name: "assessment-plan-data",
  validations: {
    exercise_detail_selected: {
      required,
    },
    assessor_options: {},
    assessor_selected: {},
    candidate_selected: {
      required,
    },
    room_selected: {},
    time: {
      required,
    },
    day_selected: {},
  },
  components: {
    datePicker: VuePersianDatetimePicker,
  },
  props: {
    isModal: {
      type: Boolean,
      default: false,
    },
    backUrl: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      title: "",
      isLoading: false,
      exerciseAlgorithmDetailLoading: false,
      errors: [],
      exercise_detail_options: [],
      candidate_options: [],
      assessor_options: [],
      room_options: [],
      assessorLoading: false,
      assessor_selected: null,
      room_selected: null,
      candidate_selected: null,
      exercise_detail_selected: null,
      items: [],
      fields: [],
      time: "",
      plans: [],
      day_options: [],
      day_selected: null,
      assessment_plan_dataLoading: false,
      start_time: "",
      end_time: "",
    };
  },
  methods: {
    handleBack() {
      if (this.isModal) {
        this.$emit("modal-end-up");
      } else {
        window.history.length > 1
          ? this.$router.go(-1)
          : this.$router.push("/");
      }
    },
    clear() {
      this.time = this.start_time;
      this.exercise_detail_selected = null;
      this.candidate_selected = null;
      this.assessor_selected = null;
      this.room_selected = null;
      this.exercise_id = null;
    },
    changes() {},
    diff_minutes(dt2, dt1) {
      var diff = (dt2.getTime() - dt1.getTime()) / 1000;
      diff /= 60;
      return Math.abs(Math.round(diff));
    },
    afterSave() {
      this.clear();
      this.isLoading = false;
    },
    save() {
      this.$v.$touch();
      if (this.$v.$anyError) {
        return;
      }
      let dt1 = new Date(
        2020,
        1,
        15,
        this.start_time.split(":")[0],
        this.start_time.split(":")[1]
      );
      let dt2 = new Date(
        2020,
        1,
        15,
        this.time.split(":")[0],
        this.time.split(":")[1]
      );
      this.isLoading = true;
      const payload = {
        exercise_algorithm_detail_id: pathOr(null, ['value'], this.exercise_detail_selected),

        day_number: pathOr(null, ['value'], this.day_selected),
        delay_from_start: this.diff_minutes(dt2, dt1),
      };
      if (this.candidate_selected){
        payload["candidate_number"] = pathOr(null, ['value'], this.candidate_selected);
      }
      if (this.assessor_selected){
        payload["assessor_number"] = pathOr(null, ['value'], this.assessor_selected);
      }
      if (this.room_selected){
        payload["room_number"] = pathOr(null, ['value'], this.room_selected);
      }

      this.$httpService
        .post(
          this.$config.api_url +
            this.$config.kanoon.assessment_plan_data.replace("{0}", 1),
          payload
        )
        .then((response) => {
          this.$notify.success(response.data.message);
          this.afterSave();
        })
        .catch((err) => {
          if (err.response.status === 400) {
            if (typeof err.response.data.message === "object") {
              err.response.data.message.forEach((element) => {
                this.errors.push(element);
              });
            } else {
              this.$notify.error(err.response.data.message);
            }
          } else {
            this.$notify.error(err.message);
          }
        })
        .finally((this.isLoading = false));
    },
    getExerciseAlgorithmDetails(template_id) {
      return this.$httpService
        .get(
          this.$config.api_url +
            this.$config.kanoon.template +
            "/" +
            template_id +
            "/exercise_algorithm_detail"
        )
        .then((response) => {
          if (response.status !== 200) {
            this.$notify.error(response.data.message);
            return;
          }
          let exercises = response.data.data;
          this.exercise_detail_options = exercises.map((ex) => {
            return {
              text: ex.caption,
              value: ex.algorithm_detail_id,
            };
          });
          return true;
        })
        .catch((err) => {
          this.$notify.error(err.message);
          return false;
        })
        .finally(() => (this.exerciseAlgorithmDetailLoading = false));
    },
    getAssessment_plan() {
      return this.$httpService
        .get(this.$config.api_url + this.$config.kanoon.assessment_plan + "/1")
        .then((response) => {
          if (response.status !== 200) {
            this.$notify.error(response.data.message);
            return;
          }
          let assessment_plan = response.data.data;

          this.start_time = assessment_plan.start_time;
          this.end_time = assessment_plan.end_time;
          this.time = assessment_plan.start_time;
          this.getExerciseAlgorithmDetails(assessment_plan.template.id);
          this.assessor_options = Array.from(
            {
              length: assessment_plan.assessor_count,
            },
            (v, k) => k + 1
          ).map((x) => {
            return {
              value: x,
              text: x,
            };
          });
          this.room_options = Array.from(
            {
              length: assessment_plan.room_count,
            },
            (v, k) => k + 1
          ).map((x) => {
            return {
              value: x,
              text: x,
            };
          });
          this.candidate_options = Array.from(
            {
              length: assessment_plan.candidate_count,
            },
            (v, k) => k + 1
          ).map((x) => {
            return {
              value: x,
              text: x,
            };
          });
          this.day_options = Array.from(
            {
              length: assessment_plan.day_count,
            },
            (v, k) => k + 1
          ).map((x) => {
            return {
              value: x,
              text: x,
            };
          });

          if (this.day_options && this.day_options.length == 1)
            this.day_selected = this.day_options[0];

          this.fields = [
            ...this.candidate_options.map((c) => c.value.toString()),
          ];

          let [start_hour, start_minute] =
            assessment_plan.start_time.split(":");
          let [end_hour, end_minute] = assessment_plan.end_time.split(":");
          (start_hour = Number(start_hour)),
            (start_minute = Number(start_minute)),
            (end_hour = Number(end_hour)),
            (end_minute = Number(end_minute));
          let times = range(start_hour, end_hour, 1).map((h) => {
            // return range(0, 55, 5).map(m => {
            //   if (
            //     (h == start_hour && m >= start_minute) ||
            //     (h > start_hour && h < end_hour) ||
            //     (h == end_hour && m <= end_minute)
            //   ) {
            //     let hour =
            //       h.toString().length == 1 ? "0" + h.toString() : h.toString();
            //     let min =
            //       m.toString().length == 1 ? "0" + m.toString() : m.toString();
            //     return hour + ":" + min;
            //   }
            // });

            return range(0, 55, 5).reduce((results, m) => {
              if (
                (h == start_hour && m >= start_minute) ||
                (h > start_hour && h < end_hour) ||
                (h == end_hour && m <= end_minute)
              ) {
                let hour =
                  h.toString().length == 1 ? "0" + h.toString() : h.toString();
                let min =
                  m.toString().length == 1 ? "0" + m.toString() : m.toString();
                results.push({
                  time: hour + ":" + min,
                });
              }
              return results;
            }, []);
          });
          this.items = times.flat();
          this.time_options = times.flat();

          this.title =
            " ( " +
            assessment_plan.template.caption +
            " " +
            assessment_plan.candidate_count +
            " " +
            this.$lang.candidate +
            " " +
            assessment_plan.assessor_count +
            " " +
            this.$lang.assessor +
            " " +
            assessment_plan.room_count +
            " " +
            this.$lang.room +
            " )";
          return true;
        })
        .catch((err) => {
          this.$notify.error(err.message);
          return false;
        })
        .finally(() => (this.assessment_planLoading = false));
    },
    getAssessment_plan_data() {
      return this.$httpService
        .get(
          this.$config.api_url +
            this.$config.kanoon.assessment_plan_data.replace("{0}", 1)
        )
        .then((response) => {
          if (response.status !== 200) {
            this.$notify.error(response.data.message);
            return;
          }
          let assessment_plan_data = response.data.data.result;
          // this.items = assessment_plan_data;
        })
        .catch((err) => {
          this.$notify.error(err.message);
          return false;
        })
        .finally(() => (this.assessment_plan_dataLoading = false));
    },
    fetchData() {
      this.getAssessment_plan();
      this.getAssessment_plan_data();
    },
  },
  created() {
    this.assessment_plan_dataLoading = true;
    this.exerciseAlgorithmDetailLoading = true;
    this.fetchData();
  },
};
</script>

<style scoped lang="css">
.btn {
  margin-bottom: 4px;
}

body {
  font: normal 14px Segoe, "Segoe UI", "DejaVu Sans", "Trebuchet MS", Verdana,
    sans-serif;
}

.diary {
  border-collapse: collapse;
  width: 100%;
  table-layout: fixed;
  border-bottom: solid 1px #ccc;
}

.diary thead .days th {
  background: #e1f2fa;
}

.diary thead .dates th {
  vertical-align: top;
  padding-bottom: 20px;
  font-weight: bold;
}

.diary thead th.empty {
  background: none;
  border: 0;
  width: 30px;
}

.diary tr td,
.diary tr th {
  border: solid 1px #ccc;
  padding: 3px;
  text-align: left;
  border-bottom: 0;
  font-weight: normal;
}

.diary tbody tr td,
.diary tbody tr th {
  height: 25px;
}

.diary th.hour {
  vertical-align: top;
  border-left: 0;
}

.diary tr.timeSlot td,
.diary tr.timeSlot th.slot {
  border-top: dashed 1px #eee;
}

.diary th.slot {
  vertical-align: top;
}

.diary .appointment {
  position: relative;
  height: 25px;
}

.diary .appointment .spanContainer {
  background: #cae6fc;
  background: rgba(189, 224, 251, 0.8);
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  border-right: solid 4px #74c0fc;
  padding: 0 5px;
  height: 25px;
  -ms-transition: all 250ms ease-out;
  transition: all 250ms ease-out;
}

.diary .appointment:hover .spanContainer {
  background: #74c0fc;
}

.diary .appointment .spanContainer .inner {
  overflow: hidden;
  height: 100%;
}

.diary .appointment .spanContainer::before {
  content: "";
  width: 0;
  height: 0;
  position: absolute;
  top: -4px;
  right: -10px;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-bottom: 8px solid #74c0fc;
}

.diary .appointment .spanContainer::after {
  content: "";
  position: absolute;
  bottom: -4px;
  right: -10px;
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-top: 8px solid #74c0fc;
}

.diary .appointment h2 {
  font-size: 14px;
  margin: 0;
  padding: 2px 0;
}

.diary .appointment ul {
  margin: 0;
  padding: 0;
  list-style: none;
  font-size: 12px;
}

.diary .appointment p {
  border-top: dashed 1px #74c0fc;
  font-size: 12px;
  margin: 5px -5px 0;
  padding: 5px;
}

.diary .appointment.hourHalf {
  height: 25px;
}

.diary .appointment.hour1 .spanContainer {
  height: 57px;
}

.diary .appointment.hour1Half .spanContainer {
  height: 89px;
}

.diary .appointment.hour2 .spanContainer {
  height: 121px;
}

.diary .appointment.hour2Half .spanContainer {
  height: 153px;
}

.diary .appointment.hour3 .spanContainer {
  height: 185px;
}

.diary .appointment.hour3Half .spanContainer {
  height: 217px;
}

.diary .appointment.hour4 .spanContainer {
  height: 249px;
}

.diary .appointment.hour4Half .spanContainer {
  height: 281px;
}

.diary .appointment.hour5 .spanContainer {
  height: 313px;
}

.diary .appointment.hour5Half .spanContainer {
  height: 345px;
}

.diary .appointment.hour6 .spanContainer {
  height: 377px;
}

.diary .appointment.hour6Half .spanContainer {
  height: 409px;
}

.diary .appointment.hour7 .spanContainer {
  height: 441px;
}

.diary .appointment.hour7Half .spanContainer {
  height: 473px;
}

.diary .appointment.hour8 .spanContainer {
  height: 505px;
}

.diary .appointment.hour8Half .spanContainer {
  height: 537px;
}

.diary .appointment.hour9 .spanContainer {
  height: 569px;
}

.diary .appointment.hour9Half .spanContainer {
  height: 601px;
}

.diary .appointment.hour10 .spanContainer {
  height: 633px;
}

.diary .appointment.hour10Half .spanContainer {
  height: 665px;
}

.diary .appointment.hour11 .spanContainer {
  height: 697px;
}

.diary .appointment.hour11Half .spanContainer {
  height: 729px;
}

.diary .appointment.hour12 .spanContainer {
  height: 761px;
}

.diary .appointment.hour12Half .spanContainer {
  height: 793px;
}

.diary .appointment.hour13 .spanContainer {
  height: 825px;
}

.diary .appointment.hour13Half .spanContainer {
  height: 857px;
}

.diary .appointment.hour14 .spanContainer {
  height: 889px;
}

.diary .appointment.hour14Half .spanContainer {
  height: 921px;
}

.diary .appointment.hour15 .spanContainer {
  height: 953px;
}

.diary .appointment.hour15Half .spanContainer {
  height: 985px;
}

.diary .appointment.hour16 .spanContainer {
  height: 1017px;
}

.diary .appointment.hour16Half .spanContainer {
  height: 1049px;
}

.diary .appointment.hour17 .spanContainer {
  height: 1081px;
}

.diary .appointment.hour17Half .spanContainer {
  height: 1113px;
}

.diary .appointment.hour18 .spanContainer {
  height: 1145px;
}

.diary .appointment.hour18Half .spanContainer {
  height: 1177px;
}

.diary .appointment.hour19 .spanContainer {
  height: 1209px;
}

.diary .appointment.hour19Half .spanContainer {
  height: 1241px;
}

.diary .appointment.hour20 .spanContainer {
  height: 1273px;
}

.diary .appointment.hour20Half .spanContainer {
  height: 1305px;
}

.diary .appointment.hour21 .spanContainer {
  height: 1337px;
}

.diary .appointment.hour21Half .spanContainer {
  height: 1369px;
}

.diary .appointment.hour22 .spanContainer {
  height: 1401px;
}

.diary .appointment.hour22Half .spanContainer {
  height: 1433px;
}

.diary .appointment.hour23 .spanContainer {
  height: 1465px;
}

.diary .appointment.hour23Half .spanContainer {
  height: 1497px;
}

.diary .appointment.hour24 .spanContainer {
  height: 1529px;
}

.diary .newAppointment {
  width: 100%;
  height: 25px;
  display: block;
  border: 0;
  padding: 0;
  margin: 0;
  background: none;
  -ms-transition: text-indent 250ms ease-out, background 250ms ease-out;
  transition: text-indent 250ms ease-out, background 250ms ease-out;
  text-indent: -200%;
  text-align: left;
  overflow: hidden;
  -webkit-border-radius: 2px;
  border-radius: 2px;
  background: no-repeat 150% center;
}

.diary .newAppointment:hover {
  text-indent: 5px;
  background: #cae6fc no-repeat 98% center;
}
</style>
